module.exports = __webpack_public_path__ + "img/signboard-printed-icon.3100fee1.svg";